@define-mixin mega {
  font-weight: 500;
  font-size: 128px;
  letter-spacing: 0.8px;
  line-height: 128px;
}

@define-mixin jumbo {
  font-weight: 500;
  font-size: 52px;
  letter-spacing: 1.4px;
  line-height: 60px;
}

@define-mixin super-hero {
  font-weight: 500;
  font-size: 46px;
  letter-spacing: 1.8px;
  line-height: 48px;
}

@define-mixin hero {
  font-weight: 500;
  font-size: 38px;
  letter-spacing: 1.2px;
  line-height: 48px;
}

@define-mixin h1 {
  font-weight: 500;
  font-size: 34px;
  letter-spacing: 1.2px;
  line-height: 44px;
}

@define-mixin h2 {
  font-weight: 500;
  font-size: 28px;
  letter-spacing: 1px;
  line-height: 36px;
}

@define-mixin h3 {
  font-weight: 700;
  font-size: 24px;
  letter-spacing: 1.6px;
  line-height: 32px;
}

@define-mixin section-title {
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 1.6px;
  line-height: 24px;
  text-transform: uppercase;
}

@define-mixin subheader-demi {
  font-weight: 700;
  font-size: 19px;
  letter-spacing: 0.8px;
  line-height: 28px;
}

@define-mixin subheader {
  font-weight: 500;
  font-size: 19px;
  letter-spacing: 0.2px;
  line-height: 28px;
}

@define-mixin body-17-demi {
  font-weight: 700;
  font-size: 17px;
  letter-spacing: 0.8px;
  line-height: 28px;
}

@define-mixin body-17 {
  font-weight: 500;
  font-size: 17px;
  letter-spacing: 0.2px;
  line-height: 28px;
}

@define-mixin body-16-demi {
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.6px;
  line-height: 24px;
}

@define-mixin body-16 {
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.3px;
  line-height: 24px;
}

@define-mixin body-15-demi {
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0.6px;
  line-height: 24px;
}

@define-mixin body-15 {
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.3px;
  line-height: 24px;
}

@define-mixin caption-demi {
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.6px;
  line-height: 20px;
}

@define-mixin caption {
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.3px;
  line-height: 20px;
}

@define-mixin label-demi {
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.6px;
  line-height: 20px;
}

@define-mixin label {
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0.4px;
  line-height: 20px;
}

@define-mixin tiny-demi {
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.8px;
  line-height: 20px;
}

@define-mixin tiny {
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.4px;
  line-height: 20px;
}

@define-mixin cent {
  font-weight: 500;
  font-size: 11px;
  letter-spacing: 0.4px;
  line-height: 20px;
}

@define-mixin micro-demi {
  font-weight: 700;
  font-size: 10px;
  letter-spacing: 1.4px;
  line-height: 24px;
}

@define-mixin micro {
  font-weight: 500;
  font-size: 10px;
  letter-spacing: 0.8px;
  line-height: 20px;
}

.underline {
  text-decoration: underline;
}

.mega {
  @mixin mega;
}
.jumbo {
  @mixin jumbo;
}
.super-hero {
  @mixin super-hero;
}
.hero {
  @mixin hero;
}
.h1 {
  @mixin h1;
}
.h2 {
  @mixin h2;
}
.h3 {
  @mixin h3;
}
.section-title {
  @mixin section-title;
}
.subheader-demi {
  @mixin subheader-demi;
}
.subheader {
  @mixin subheader;
}
.body-17-demi {
  @mixin body-17-demi;
}
.body-17 {
  @mixin body-17;
}
.body-16-demi {
  @mixin body-16-demi;
}
.body-16 {
  @mixin body-16;
}
.body-15-demi {
  @mixin body-15-demi;
}
.body-15 {
  @mixin body-15;
  & b {
    font-weight: 700;
  }
}
.caption-demi {
  @mixin caption-demi;
}
.caption {
  @mixin caption;
}
.label-demi {
  @mixin label-demi;
}
.label {
  @mixin label;
}
.tiny-demi {
  @mixin tiny-demi;
}
.tiny {
  @mixin tiny;
}
.cent {
  @mixin cent;
}
.micro-demi {
  @mixin micro-demi;
}
.micro {
  @mixin micro;
}

/*
  Forces the style to be demi.
  Main use case:
  We don't want text that's bolded directly next to non-bolded text (as in the search bar or dropdown options where
  the part the user has typed is bold) to have different letter-spacing than the counterpart text that isn't bold.
  so, only change the font-weight, whereas most demi font variants also change letter-spacing.
*/
.force-demi {
  font-weight: 700;
}

/* We don't have any design-system suggestions for italics yet afaik */
.italic {
  font-style: italic;
}

.h2-el {
  margin-top: 24px;
  margin-bottom: 24px;
}

.section-name-el {
  margin-bottom: 8px;
  color: var(--ds-pearl-grey-darkest);
}
